export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ04.cce80af9.mp3";